(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["game-page"] && !Shopify.designMode) return;
  try {
    
  function renderKitchenGameBoard(board, data) {
    const labels = data.labels;
    const flags = { hu: '🇭🇺', cs: '🇨🇿', sk: '🇸🇰', ro: '🇷🇴', pl: '🇵🇱' };
    const rowFor = (entry) => {
      const row = document.createElement('div');
      row.className = 'hg-leaderboard__row';
      if (entry.you) row.dataset.you = 'true';
      const rank = document.createElement('span'); rank.textContent = `#${entry.rank}`;
      const name = document.createElement('span'); name.textContent = `${flags[entry.country] || ''} ${entry.name}${entry.you ? ` · ${labels.you}` : ''}`;
      const points = document.createElement('span'); points.textContent = entry.score;
      row.append(rank, name, points);
      return row;
    };
    board.querySelector('.hg-block-eyebrow').textContent = labels.top;
    board.querySelector('h2').textContent = labels.heading;
    const mine = board.querySelector('.hg-leaderboard__mine');
    const mineTitle = document.createElement('strong'); mineTitle.textContent = labels.your;
    if (data.me) mine.replaceChildren(mineTitle, rowFor(data.me));
    else {
      const note = document.createElement('p');
      if (data.closed) note.textContent = labels.noRank;
      else if (!data.player.registered) {
        const join = document.createElement('button');
        join.type = 'button';
        join.className = 'hg-leaderboard__register';
        join.textContent = labels.guestLink;
        join.addEventListener('click', () => {
          board.closest('.hg-page')?.querySelector('hunger-game-embed')?.openRegistration();
        });
        note.append(join, document.createTextNode(` ${labels.guestRest}`));
      } else note.textContent = !data.player.verified ? labels.unverified : labels.unranked;
      mine.replaceChildren(mineTitle, note);
    }
    const columns = board.querySelector('.hg-leaderboard__columns').children;
    columns[0].textContent = labels.rankChef;
    columns[1].textContent = labels.points;
    const list = board.querySelector('.hg-leaderboard__list');
    list.setAttribute('aria-label', labels.top);
    list.replaceChildren();
    if (data.rows.length) list.append(...data.rows.map(rowFor));
    else {
      const empty = document.createElement('p'); empty.className = 'hg-leaderboard__empty'; empty.textContent = labels.empty;
      list.append(empty);
    }
    board.querySelector('.hg-leaderboard__rule').textContent = data.closed ? labels.closed + '. ' + labels.rule : labels.rule;
    const playerRow = list.querySelector('[data-you="true"]');
    if (playerRow) requestAnimationFrame(() => {
      list.scrollTop += playerRow.getBoundingClientRect().top - list.getBoundingClientRect().top - (list.clientHeight - playerRow.clientHeight) / 2;
    });
  }

  if (!customElements.get('hunger-game-embed')) {
    customElements.define('hunger-game-embed', class extends HTMLElement {
      openRegistration() {
        const frame = this.querySelector('iframe');
        if (!frame?.contentWindow) return;
        frame.contentWindow.postMessage({ type: '180-arcade:open-registration' }, new URL(this.dataset.origin).origin);
        frame.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        const url = new URL(this.dataset.origin);
        url.searchParams.set('embed', '1');
        url.searchParams.set('game', this.dataset.game);
        url.searchParams.set('locale', this.dataset.locale);
        const frame = document.createElement('iframe');
        frame.src = url.toString();
        frame.title = this.dataset.title;
        frame.loading = 'eager';
        frame.allow = 'fullscreen';
        frame.addEventListener('load', () => this.classList.add('is-ready'), { once: true });
        this.onBoard = (event) => {
          if (event.source !== frame.contentWindow || event.origin !== url.origin) return;
          const data = event.data;
          if (data?.type !== '180-arcade:leaderboard' || data.game !== this.dataset.game || !Array.isArray(data.rows)) return;
          const board = this.closest('.hg-page')?.querySelector('.hg-leaderboard');
          if (board) renderKitchenGameBoard(board, data);
        };
        window.addEventListener('message', this.onBoard);
        this.append(frame);
      }
      disconnectedCallback() { if (this.onBoard) window.removeEventListener('message', this.onBoard); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
